export default (value, obj) => {
  value = value.replace(new RegExp('<br>', 'g'), '\n')

  const el = document.createElement('span')

  el.innerHTML = value

  for (let i = 0; i < el.children.length; i++) {
    if (!el.children[i].classList.contains('chat-field')) {
      if (el.children[i].children[0]) {
        const element = el.children[i].children[0].cloneNode()

        el.replaceChild(element, el.children[i])
      }
    }
  }

  const chatFields = el.getElementsByClassName('chat-field')

  for (let i = 0; i < chatFields.length; i++) {
    const property = chatFields[i].attributes.getNamedItem('property')

    const names = property.value.split('.')

    const propertyValue = names.reduce((previous, current) => {
      if (previous) {
        return previous[current]
      }
    }, obj)

    if (propertyValue) {
      const value = document.createElement('span')

      value.innerText = propertyValue

      el.replaceChild(value, chatFields[i])
    }
  }

  return el.textContent
}
